import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, X, Menu } from 'lucide-react';
import GradientBar from './GradientBar';

const TopBar = ({ title, onBack, onClose, onMenu, showMenu = false }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <GradientBar className="px-6 py-10 flex items-center justify-between">
      {/* Left Icon */}
      {onBack && (
        <button onClick={handleBack} className="text-brand-ink" data-testid="back-button">
          <ArrowLeft size={30} />
        </button>
      )}
      {onClose && (
        <button onClick={onClose} className="text-brand-ink" data-testid="close-button">
          <X size={30} />
        </button>
      )}
      {!onBack && !onClose && <div className="w-8"></div>}

      {/* Title */}
      <h1 className="font-brand text-2xl text-brand-ink flex-1 ml-2.5" data-testid="top-bar-title">
        {title}
      </h1>

      {/* Right Icon */}
      {showMenu && onMenu && (
        <button onClick={onMenu} className="text-brand-ink" data-testid="menu-button">
          <Menu size={30} />
        </button>
      )}
      {!showMenu && <div className="w-8"></div>}
    </GradientBar>
  );
};

export default TopBar;